import React, { useRef, useState } from 'react';
import { Paperclip, X } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';

export const PageAttachments = ({ attachments, setForm, uploadFile, onPreview, onBusyChange }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [dragging, setDragging] = useState(false);
  const upload = async files => {
    if (!files?.length || busy) return;
    setBusy(true); onBusyChange(true);
    try {
      const added = [];
      for (const file of Array.from(files)) {
        const result = await uploadFile(file);
        if (result) added.push(result);
      }
      if (added.length) {
        setForm(prev => ({ ...prev, attachments: [...(prev.attachments || []), ...added] }));
        toast.success(`${added.length} attachment${added.length > 1 ? 's' : ''} added`);
      }
    } finally { setBusy(false); onBusyChange(false); }
  };
  return <section data-testid="kb-attachment-dropzone" className={`border-t pt-4 space-y-3 ${dragging ? 'bg-indigo-50' : ''}`}
    onDragOver={e => { e.preventDefault(); setDragging(true); }} onDragLeave={() => setDragging(false)}
    onDrop={e => { e.preventDefault(); setDragging(false); upload(e.dataTransfer.files); }}>
    <h2 className="text-sm font-semibold text-slate-800">Attachments</h2>
    <Button data-testid="kb-attach-browse" disabled={busy} size="sm" variant="outline" onClick={() => input.current?.click()}><Paperclip className="mr-2 h-4 w-4" />{busy ? 'Uploading…' : 'Choose files'}</Button>
    <input ref={input} className="hidden" type="file" multiple data-testid="kb-attachment-input" onChange={e => { upload(e.target.files); e.target.value = ''; }} />
    <ul className="space-y-2">{attachments.map((att, index) => <li data-testid={`kb-form-attachment-${att.id}`} key={att.id} className="flex items-start gap-1 min-w-0">
      <button data-testid={`kb-form-preview-${att.id}`} className="text-xs text-left flex-1 min-w-0 [overflow-wrap:anywhere] text-indigo-700 hover:underline" onClick={() => onPreview(index)} title="Preview attachment">{att.filename}<span className="block text-slate-500">{Math.max(1, Math.round((att.size || 0) / 1024))} KB</span></button>
      <button data-testid={`kb-remove-attachment-${att.id}`} title="Remove attachment" className="shrink-0 p-1 text-slate-500 hover:text-red-600" onClick={() => setForm(prev => ({ ...prev, attachments: prev.attachments.filter(a => a.id !== att.id) }))}><X className="h-3 w-3" /></button>
    </li>)}</ul>
  </section>;
};